//Small initialization scripts
$(document).ready(function(){
	//product and comments star rating 
	$('#product-rating,.comment-rating').barrating({
        theme: 'bootstrap-stars',
        showSelectedRating: false
    });

	//Right Sidebar Fab Color Boxes Selection 
	$('div.fab-color-box').click(function(){
	    $('div.fab-color-box.fab-col-active').removeClass('fab-col-active');
	    $(this).addClass("fab-col-active");
	});

	//Right Sidebar Product Size Selection
	$('div.size-box').click(function(){
	    $('div.size-box.active-size-box').removeClass('active-size-box');
	    $(this).addClass("active-size-box");
	});		

	//activate love symbol
	$('#lovesymbol').click(function(){
		$(this).css('color', '#FC7C63');
	});
	
	//Activate Popovers
	$('[data-toggle="popover"]').popover();


	$(".fancybox").fancybox({'width':900,
		'height':500,
		'autoSize' : false});


});